import { Text } from '@rneui/themed'
import { onlineManager } from '@tanstack/react-query'
import React from 'react'
import { StyleSheet, View } from 'react-native'

type Props = {
  title: string
  color?: string
  showCaret?: boolean
}

export function Title({ title, showCaret = true, color }: Props) {
  return (
    <View style={[styles.container]}>
      <Text style={[styles.title, { color }]} numberOfLines={1}>
        {title}
      </Text>
      {onlineManager.isOnline() && showCaret ? (
        <Text style={[styles.caret, { color }]}>{`›`}</Text>
      ) : null}
    </View>
  )
}

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 2,
  },
  title: {
    fontSize: 16,
    lineHeight: 30,
    opacity: 0.6,
  },
  caret: {
    fontSize: 30,
    lineHeight: 30,
    opacity: 0.4,
  },
})
